import axios from "axios"
import authAxios from "../axios-instance/authAxios";

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export const UserAuthApi = {
    LoginWithGoogleFirebase,
    getUserInfo,
    reissueAccessToken,
    Signout,
    DeletionAccount,
    SendVerificationSmsForChangePhoneNumber,
    SendVerificationSmsForFindUser,
    ChangePhoneNumber,
    FindUser,
}

async function LoginWithGoogleFirebase({ headers, params, body }) {
    return await axios.post(`${MAIN_API_HOST}/v2/public/login-with-google-firebase`, body, {
        headers: headers,
        params: params,
        withCredentials: true,
    })
}

async function getUserInfo({ headers, params, body }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/user-auth/user-info`, {
        headers: headers,
        params: params,
    })
}

async function reissueAccessToken() {
    const res = await axios.post(
        `${MAIN_API_HOST}/v2/public/user-auth/reissue-access-token`,
        null,
        { withCredentials: true }
    );
    return res.data?.data?.accessToken;
}

async function Signout({
    headers, params, body
}) {
    return await authAxios.post(`${MAIN_API_HOST}/v2/public/signout`, body, {
        headers: headers,
        params: params,
    })
}

async function DeletionAccount({
    headers, params, body
}) {
    return await authAxios.post(`${MAIN_API_HOST}/v2/public/deletion-account`, body, {
        headers: headers,
        params: params,
    })
}

async function SendVerificationSmsForChangePhoneNumber({ headers, params, body }) {
    return await authAxios.post(`${MAIN_API_HOST}/v2/public/user-auth/send-verification-sms/change-phone-number`, body, {
        headers: headers,
        params: params,
    })
}

async function SendVerificationSmsForFindUser({ headers, params, body }) {
    return await axios.post(`${MAIN_API_HOST}/v2/public/user-auth/send-verification-sms/find-user`, body, {
        headers: headers,
        params: params,
        withCredentials: true,
    })
}

async function ChangePhoneNumber({
    headers, params, body
}) {
    return await authAxios.patch(`${MAIN_API_HOST}/v2/public/user-auth/change-phone-number`, body, {
        headers: headers,
        params: params,
    })
}

async function FindUser({
    headers, params, body
}) {
    return await axios.post(`${MAIN_API_HOST}/v2/public/user-auth/find-user`, body, {
        headers: headers,
        params: params,
        withCredentials: true,
    })
}